module.exports = __webpack_public_path__ + "img/performance-3.5732e26e.png";